import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { autoUnsubWith, Utility } from '../../services/utility.abstract';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { CompanyService, BreadcrumbItem } from '../../services/company.service';
import { ToastService } from '../../services/toast.service';
import { DriverService } from '@core/services/driver.service';
import { Location } from '@angular/common';
import { MenuService } from '@core/services/menu.service';
import { CommonFunctions } from '@shared/common-functions';
import { CommonMenuService } from '@shared/services/common-util.service';
import { DriverService as SharedDriverService } from '@shared/components/driver/services/driver.service';
import {
  CANCEL_BOOKING_CONFIRMATION_MODEL,
  DEFAULT_LOGO,
  END_DATE_GREATER,
  itemsPerPageList,
  MARK_AS_PAID_CONFIRMATION,
  PAYMENT_MODE,
  SELECT_BOTH_DATES,
  USER_ROLES,
  USER_TYPE,
} from '@shared/constant/shared.constant';
import { BookingInvoiceComponent } from '../booking-invoice/booking-invoice.component';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import {
  InvoicePaymentStatus,
  PaymentMode,
} from '@core/models/api-response.model';
import { CancelModalComponent } from '../cancel-modal/cancel-modal.component';
import { InvoiceType } from '../custom-invoice/custom-invoice.component';
import { ItemPerPage } from '@core/models/file-response.model';
import { ReloadService } from '@shared/services/reload.service';
import { PayRepayModalComponent } from '../pay-repay-modal/pay-repay-modal.component';
import { SuperAdminService } from '@core/services/super-admin.service';
import { SharedInvoicePopupComponent } from '../shared-invoice-popup/shared-invoice-popup.component';
import { BookingFlowService } from '../booking-flow/service/booking-flow.service';
import { DriverList } from '@core/models/booking.model';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-invoice-booking',
  templateUrl: './invoice-booking.component.html',
  styleUrls: ['./invoice-booking.component.scss'],
})
export class InvoiceBookingComponent implements OnInit,OnDestroy{
  readonly destroyRef = inject(DestroyRef);
  invoiceList: any;
  itemsPerPage: number = 10;
  totalRecords: number;
  currentSkip: number = 0;
  currentPageUpcoming: number = 1;
  name: string;
  email: string;
  phoneNumber: any;
  invoiceNumber: string;
  selectDriverStatus: any;
  CustomItemPerPageBy: ItemPerPage[] = itemsPerPageList;
  items: MenuItem[] | undefined;
  SearchItemPerPageBy: any;
  dummy = DEFAULT_LOGO;
  activeItem: any;
  excelFile: DriverList[] = [];
  invoiceListRequest: any;
  goToCurrentTab: boolean = false;
  showInput: boolean = false;
  role: string = '';
  roleRoute: string = '';
  searchStatus: number = null;
  selectStatus: { name: string; value: number }[] = [];
  chackFilterType: boolean = false;
  companyId: string = '';
  createInvoiceCheck: boolean = false;
  startDate: any = null;
  endDate: any = null;
  isAlternateDesign: boolean = false;
  invoicePaymentStatus = InvoicePaymentStatus;
  reloadSubscription: any;

  constructor(
    private readonly driverService: DriverService,
    private readonly sharedDriverService: SharedDriverService,
    private readonly dialogControlService: DialogControlService,
    private readonly toastService: ToastService,
    private readonly companyService: CompanyService,
    private readonly menuService: MenuService,
    private readonly location: Location,
    private readonly router: Router,
    private readonly commonMenuService: CommonMenuService,
    private readonly reloadService: ReloadService,
    private readonly superAdminService: SuperAdminService,
    private readonly bookingFlowService: BookingFlowService,
    private readonly confirmationService: ConfirmationService,
    private readonly encryptStorage: EncryptionStorageService
  ) {
    this.role = this.encryptStorage.getItem('roleName');
    this.roleRoute = CommonFunctions.routeToBookingDetail(this.role);
  }

  ngOnInit() {
    this.createInvoiceCheck = this.menuService.shortNameExists(
      JSON.parse(this.encryptStorage.getItem('menuData')),
      85
    );
    this.selectStatus = [
      { name: 'All', value: null },
      { name: 'Paid', value: 1 },
      { name: 'Pending', value: 0 },
      { name: 'In-Process', value: 3 },
      { name: 'Cancelled', value: 4 },
      { name: 'Payment Failed', value: 2 },
    ];
    this.superAdminService.popupClosed$.subscribe((refresh) => {
      if (refresh) {
        this.getInvoiceListBookings('firsttime');
      }
    });
    this.getInvoiceListBookings('firsttime');
    let breadcrumbObj: BreadcrumbItem[] = [];
    if (
      this.role !== USER_ROLES.DRIVER &&
      this.role !== USER_ROLES.GROUP_USER
    ) {
      breadcrumbObj = [{ title: 'Manage Invoices' }, { title: 'Invoice List' }];
    } else {
      breadcrumbObj = [{ title: 'My Invoices' }];
    }
    this.companyService.setAdminHeaders('0', breadcrumbObj);
    this.goToTop();
    this.companyId = this.encryptStorage.getItem('companyId');
    this.reloadSubscription = this.reloadService.reload$.subscribe(() => {
      this.getInvoiceListBookings('search');
    });
  }

  ngOnDestroy() {
    if (this.reloadSubscription) {
      this.reloadSubscription.unsubscribe(); // Clean up the subscription
    }
  }

  filterConfig = {
    [USER_ROLES.SUPER_ADMIN]: [
      'name',
      'phoneNumber',
      'email',
      'paymentStatus',
      'invoiceNumber',
    ],
    [USER_ROLES.DRIVER]: [
      'startDate',
      'endDate',
      'paymentStatus',
      'invoiceNumber',
    ],
    [USER_ROLES.GROUP_USER]: [
      'startDate',
      'endDate',
      'paymentStatus',
      'invoiceNumber',
    ],
    [USER_ROLES.PARKING_MANAGER]: [
      'name',
      'phoneNumber',
      'email',
      'paymentStatus',
      'invoiceNumber',
    ],
    [USER_ROLES.PARKING_OWNER]: [
      'name',
      'phoneNumber',
      'email',
      'paymentStatus',
      'invoiceNumber',
    ],
  };

  isFilterVisible(filterName: string): boolean {
    const visibleFilters = this.filterConfig[this.role] || [];
    return visibleFilters.includes(filterName);
  }

  getInvoiceListBookings(changeAction) {

    let request;
    let bookingMethod;
    if (
      this.role === USER_ROLES.DRIVER ||
      this.role === USER_ROLES.GROUP_USER
    ) {
      request = {
        startDate: this.startDate,
        endDate: this.endDate,
        parkingLotName: null,
        paymentStatus: this.searchStatus,
        invoiceNumber: this.invoiceNumber || '',
        timeZone: Utility.getLocalTimeZone(),
      };
      bookingMethod = 'getInvoiceListBookingsDriver';
    } else {
      request = {
        name: this.name || '',
        phoneNumber: this.phoneNumber || '',
        email: this.email || '',
        invoiceNumber: this.invoiceNumber || '',
        paymentStatus: this.searchStatus,
        timeZone: Utility.getLocalTimeZone(),
      };
      bookingMethod = 'getInvoiceListBookings';
    }
    let pageNumber: number;
    let pageSize: number;

    switch (changeAction) {
      case 'reset':
        pageNumber = 1;
        pageSize = this.itemsPerPage;
        break;
      case 'search':
        pageNumber = 1;
        pageSize = this.itemsPerPage;
        break;
      case 'export':
        pageNumber = 0;
        pageSize = 0;
        break;
      default:
        pageNumber = this.currentPageUpcoming;
        pageSize = this.itemsPerPage;
        break;
    }
    this.invoiceListRequest = {
      ...request,
      pageNumber,
      pageSize,
    };

    this.driverService[bookingMethod](this.invoiceListRequest)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        if (changeAction != 'export') {
          this.totalRecords = response.data.totalRecords;
          this.invoiceList = response.data.spOutput;
        }
        if (changeAction === 'search') {
          this.currentSkip = 0;
          CommonFunctions.scrollTopRow('top');
        }
        if (changeAction === 'export') {
          this.excelFile = response.data.spOutput;
          this.export();
        }

},
      error: (_error) => {
        this.currentSkip = 0;
        this.invoiceList = [];
      },
    });
  }

  get isAdminOrOwnerRole(): boolean {
    return CommonFunctions.isAdminOrOwnerRole(this.role);
  }

  get isDriverOrGroupUser(): boolean {
    return this.role === USER_ROLES.DRIVER || this.role === USER_ROLES.GROUP_USER;
  }
  goToCrmPage(rowData: any) {
  const isGroupOperator = rowData?.userType === USER_TYPE.GROUP_OPERATOR;

  const page = isGroupOperator ? 'group-operator-info' : 'driver-info';
  const queryParam = isGroupOperator ? 'Id' : 'id';

  CommonFunctions.navigateToCRM(
    this.roleRoute,
    rowData.userRoleId,
    this.router,
    this.sharedDriverService,
    page,
    queryParam,
    '0'
  );
}

  checkDataTimeValidation() {
    const startDate = this.startDate ? new Date(this.startDate) : null;
    const endDate = this.endDate ? new Date(this.endDate) : null;
    this.startDate?.setHours(0, 0, 0, 0);
    this.endDate?.setHours(23, 59, 59, 999);
    if ((startDate && !endDate) || (!startDate && endDate)) {
      this.toastService.showToastMessage('error', 'Error', SELECT_BOTH_DATES);
      return;
    } else if (startDate && endDate) {
      if (startDate > endDate) {
        this.toastService.showToastMessage('error', 'Error', END_DATE_GREATER);
        return;
      }
    }
    this.getInvoiceListBookings('Search');
  }

  onChangePaymentStatus(event: any) {
    this.searchStatus = event.value;
  }

  onPageChange(event: any) {
    this.currentSkip = event.first;
    this.currentPageUpcoming = event.page + 1;
    CommonFunctions.scrollTopRow('top');
    this.getInvoiceListBookings('pageChange');
  }
    getTimeZoneAbbreviation(timeZone: string): string {
    return CommonFunctions.getTimeZoneAbbreviation(timeZone);
  }

  onDropdownChange(event: any) {
    this.itemsPerPage = event.value;
    this.currentSkip = 1;
    this.currentPageUpcoming = 1;
    CommonFunctions.scrollTopRow('top');
    this.getInvoiceListBookings('dropdownchange');
  }

  getFlagClass(iso: string): string {
    const lowerCaseIso = iso?.toLowerCase();
    return `fi fi-${lowerCaseIso}`;
  }

  resetFilter() {
    this.name = '';
    this.email = '';
    this.invoiceNumber = '';
    this.startDate = null;
    this.endDate = null;
    this.currentPageUpcoming = 1;
    this.itemsPerPage = 10;
    this.currentSkip = 0;
    this.phoneNumber = '';
    this.searchStatus = null;
    this.SearchItemPerPageBy = null;
    this.getInvoiceListBookings('reset');
    this.goToTop();
  }

  goToTop() {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  }

  openCancelModal(bookindId) {
    this.dialogControlService.openDialog(CancelModalComponent, {
      width: '20%',
      data: {
        comingFromInvoice: true,
        bookingId: bookindId,
        headerText: 'Cancel',
        bodyText: CANCEL_BOOKING_CONFIRMATION_MODEL,
      },
    });
    this.dialogControlService.onClose().subscribe((result) => {
      if (result.status) {
        this.getInvoiceListBookings('firsttime');
      }
    });
  }
  exportMenu() {
    this.isAlternateDesign = false;
    this.items = [
      {
        items: [
          {
            label: 'Export',
            icon: 'pi pi-download',
            command: () => {
              this.getInvoiceListBookings('export');
            },
          },
        ],
      },
    ];
  }
  showDataForDriver(rowData: any) {
    this.isAlternateDesign = true;
    const actionMap = {
      bookingSummary: () => this.openInvoice(rowData.id),
      viewInvoice: () => this.downloadInvoice(rowData.id),
      pay: () => {
        this.dialogControlService.openDialog(PayRepayModalComponent, {
          styleClass: 'pay-repay',
          data: {
            id: rowData.id,
            invoiceId: null,
            driverId: rowData.userRoleId,
            bookingType: true,
            role: this.role,
          },
        });
        this.dialogControlService.onClose().subscribe(() => {
          this.getInvoiceListBookings('search');
        });
      },
      customCancel: () => {
        this.openCancelModal(rowData.id);
      },
    };

    const config = [
      {
        label: '',
        icon: '',
      },
      {
        label: 'View Invoice',
        icon: 'common-icon view-profile',
        escape: false,
        command: actionMap.viewInvoice,
      },
      {
        label: 'Booking Summary',
        icon: 'common-icon booking-summary',
        command: actionMap.bookingSummary,
      },
      {
        label: 'Re-Pay',
        icon: 'common-icon custom-pay',
        visible:
          rowData?.paymentStatus === this.invoicePaymentStatus.PaymentFailed,
        command: actionMap.pay,
      },
      {
        label: 'Pay',
        icon: 'common-icon custom-pay',
        visible: rowData?.paymentStatus === this.invoicePaymentStatus.Pending,
        command: actionMap.pay,
      },
    ];
    this.items = this.commonMenuService.commonShowData(config);
  }

  showData(rowData: any, event: any) {
    this.isAlternateDesign = true;
    const actionMap = {
      rersevationDetails: () =>
        this.navigateToBookingDetails(rowData.id, rowData?.userType),
      bookingSummary: () => this.openInvoice(rowData.id),
      viewInvoice: () => this.downloadInvoice(rowData.id),
      customPay: () => {
        this.dialogControlService.openDialog(PayRepayModalComponent, {
          styleClass: 'pay-repay',
          data: {
            id: rowData.id,
            invoiceId: null,
            driverId: rowData.userRoleId,
            bookingType: true,
            role: this.role,
          },
        });

        this.dialogControlService.onClose().subscribe(() => {
          this.getInvoiceListBookings('search');
        });
      },
      customCancel: () => {
        this.openCancelModal(rowData.id);
      },
      markAsPaid: (product, event) => {
        this.confirmationService.confirm({
          target: event.target as EventTarget,
          message: MARK_AS_PAID_CONFIRMATION,
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.markAsPaidFunc(product?.id);
          },
        });
      },
    };

    const config = [
      {
        label: '',
        icon: '',
      },
      {
        label: 'Share Invoice',
        icon: 'common-icon share-invoice',
        escape: false,
        command: () => {
          this.dialogControlService.openDialog(SharedInvoicePopupComponent, {
            styleClass: 'shareinvoice-model',
            data: {
              bookingId: rowData?.id,
              email: rowData?.email,
              mobileNumber: rowData?.phoneNumber
                ? rowData?.countryCode + ' ' + rowData?.phoneNumber
                : null,
              isBookingExist: true,
            },
          });
        },
      },
      {
        label: 'View Invoice',
        icon: 'common-icon view-profile',
        escape: false,
        command: actionMap.viewInvoice,
      },
      {
        label: 'Booking Details',
        icon: 'common-icon reservation-details',
        command: actionMap.rersevationDetails,
      },
      {
        label: 'Re-Pay',
        icon: 'common-icon custom-pay',
        visible:
          rowData?.paymentStatus === this.invoicePaymentStatus.PaymentFailed,
        command: actionMap.customPay,
      },
      {
        label: 'Pay',
        icon: 'common-icon custom-pay',
        visible: rowData?.paymentStatus === this.invoicePaymentStatus.Pending,
        command: actionMap.customPay,
      },
      {
        label: 'Mark as Paid',
        icon: 'common-icon mark-as-paid',
        escape: false,
        visible:
          rowData?.paymentStatus === this.invoicePaymentStatus.PaymentFailed ||
          rowData?.paymentStatus === this.invoicePaymentStatus.Pending || rowData?.paymentStatus === this.invoicePaymentStatus.CheckoutUrlGenrated,
        command: () => actionMap.markAsPaid(rowData, event),
      },
    ];

    this.items = this.commonMenuService.commonShowData(config);
  }

  markAsPaidFunc(bookingId: string) {
    let request = {
      bookingId: bookingId,
      timeZone: Utility.getLocalTimeZone(),
    };
    this.bookingFlowService.createBookingPaymentOffline(request)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (_response: any) => {
        this.getInvoiceListBookings('firsttime');
        this.toastService.showToastMessage(
          'success',
          'Success',
          'Booking invoice has been marked as paid.'
        );

      },
      error: (error) => {
        this.toastService.showToastMessage(
          'error',
          'Error',
          error?.error?.message
        );

      },
    });
  }

  openInvoice(bookingId: string) {
    this.dialogControlService.openDialog(BookingInvoiceComponent, {
      width: '90%',
      data: {
        bookingId: bookingId,
        updateSlot: true,
      },
    });
  }

  private navigateToBookingDetails(bookingId: string, userType: string) {
    this.router.navigate(
      [
        `${this.roleRoute}/${
          userType === USER_TYPE.GROUP_OPERATOR
            ? 'group-booking-details'
            : 'booking-details'
        }`,
      ],
      {
        queryParams: { id: bookingId },
      }
    );
  }

  downloadInvoice(id) {

    const req = {
      InvoiceType: InvoiceType.BookingInvoice,
      id: id,
    };

    this.driverService
      .downloadInvoice(req)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (_response) => {
          const url = _response.data as string;
          window.open(url, '_blank');
        },
        error: (er: HttpErrorResponse) => {
          this.toastService.showToastMessage(
            'error',
            'Error',
            er.error.message
          );
        },
      });
  }

  onlyNumber(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  backRoute() {
    this.location.back();
  }

  export() {
    if (this.excelFile) {
      const headers = [
        { header: 'S. No.', key: 'index', formatter: (value) => value + 1 },
        ...(this.isAdminOrOwnerRole
          ? [
              {
                header: 'Parking Lot',
                key: 'parkingLotName',
                formatter: (value) => value,
              },
            ]
          : [
              {
                header: 'Name',
                key: 'name',
                formatter: (_value, item) =>
                  item.userType === 'Group Operator'
                    ? item.groupName
                    : item.name,
              },
            ]),
        { header: 'Invoice Number', key: 'invoiceNumber' },
        ...(this.isAdminOrOwnerRole && [{ header: 'Email', key: 'email' }]),
        ...(this.isAdminOrOwnerRole && [
          {
            header: 'Mobile Number',
            key: 'phoneNumber',
            formatter: (_value, item) =>
              `${item.countryCode}${item.phoneNumber}`,
          },
        ]),

        ...(this.isAdminOrOwnerRole && [
          { header: 'User Type', key: 'userType' },

        ]),
        ...(this.isAdminOrOwnerRole && [{ header: 'Company', key: 'company' }]),
        ...[{ header: 'Parking Lot', key: 'parkingLotName' }],
        ...[{ header: 'Generated By', key: 'generatedBy' }],
        {
          header: 'Booking Type',
          key: 'bookingType',
          formatter: (value, item) =>
            value > 0 || item.parentId != null ? 'Recurring' : 'One Time',
        },
        { header: 'Arrival Date & Time', key: 'arrivalDate' },
        { header: 'Departure Date & Time', key: 'departureDate' },
        { header: 'Time Zone', key: 'timeZone', formatter: (value) => value ? this.getTimeZoneAbbreviation(value) : '-' },
        { header: 'Created Date & Time', key: 'createdDate' },
        { header: 'Amount ($)', key: 'amount' },

        {
          header: 'Payment Mode',
          key: 'bookingPaymentMode',
          formatter: (value) =>
            value === PaymentMode.Online
              ? PAYMENT_MODE.ONLINE
              : value === PaymentMode.Offline
              ? PAYMENT_MODE.OFFLINE
              : '',
        },
        { header: 'Payment Status', key: 'paymentStatusLabel' },
          ...( this.isAdminOrOwnerRole
        ? [
            {
              key: 'cancellationReason',
              header: 'Cancellation Reason',
              formatter: (value) => value || '-',
            },
            {
              key: 'cancellationReasonDetail',
              header: 'Additional Notes',
              formatter: (value) => value || '-',
            },
          ]
        : []),
    ];
      const dataWithIndex = this.excelFile.map((item, index) => ({
        ...item,
        index,
      }));

      return CommonFunctions.exportToExcel(
        dataWithIndex,
        headers,
        'Invoice List_'
      );
    }
  }

  formatDateAndTime(inputDate) {
    const date = new Date(inputDate);
    const monthAbbreviation = new Intl.DateTimeFormat('en-US', {
      month: 'short',
    }).format(date);
    const day = date.getDate();
    const year = date.getFullYear();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const formattedDay = String(day).padStart(2, '0');
    const formattedHour = String(hour).padStart(2, '0');
    const formattedMinute = String(minute).padStart(2, '0');
    const formattedDate = `${monthAbbreviation} ${formattedDay}, ${year} - ${formattedHour}:${formattedMinute}`;
    return formattedDate;
  }
  getRoleBasedSearchFunction(search: string): void {
    const isDriverOrGroupUser =
      this.role === USER_ROLES.DRIVER || this.role === USER_ROLES.GROUP_USER;
    return isDriverOrGroupUser
      ? this.checkDataTimeValidation()
      : this.getInvoiceListBookings(search);
  }
}
